import MainLayout from "screens/partials/layout";
import StorboltProfileComponent from "screens/partials/profile";

export default function ProfilePage() {
    return (
        <MainLayout>
            <StorboltProfileComponent/>
        </MainLayout>
    )
}